module.exports = __webpack_public_path__ + "static/media/Arsen Safaryan.45d6a73b.jpg";